import PersonalTariffsPage from '@/pages/PersonalTariffsPage.vue';
import PersonalPayPage from '@/pages/PersonalPayPage.vue';
import AccountDetailPage from '@/pages/AccountDetailPage.vue';
import PersonalNotificationSettingsPage from '@/pages/PersonalNotificationSettingsPage.vue';
import AccountForm from '@/components/AccountForm.vue';
import UserDetailSelfPage from '../../pages/user/UserDetailSelfPage.vue';

export default [
  {
    path: '/personal/account',
    name: 'account',
    component: AccountDetailPage,
    meta: { title: 'Аккаунт' },
    children: [
      {
        path: 'edit/:category',
        name: 'account-edit',
        component: AccountForm,
      },
    ],
  },
  {
    path: '/personal/account2/:tab',
    name: 'account2',
    component: UserDetailSelfPage,
  },
  {
    path: '/personal/notifications',
    name: 'notification-settings',
    component: PersonalNotificationSettingsPage,
    meta: { title: 'Уведомления' },
  },
  {
    path: '/personal/tariffs',
    name: 'tariffs',
    component: PersonalTariffsPage,
    meta: { title: 'Тарифы' },
  },
  {
    path: '/personal/tariffs/:tariffId/pay',
    name: 'pay',
    component: PersonalPayPage,
    meta: { title: 'Оплата' },
  },
];
